import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { BannerId, Banners } from './types'

export const initialState: Banners = {
  bannerById: {}
}

export const slice = createSlice({
  name: 'banners',
  initialState,
  reducers: {
    upsertBanner: (
      state,
      { payload }: PayloadAction<{ bannerId: BannerId; isClosed: boolean }>
    ) => {
      const { bannerId, isClosed } = payload

      if (!state.bannerById[bannerId]) {
        return
      }

      state.bannerById[bannerId]!.isClosed = isClosed
    }
  }
})

export const actions = slice.actions
export const reducer = slice.reducer
